import { render } from "./wxPosterIndex.vue?vue&type=template&id=72a854d0&scoped=true"
import script from "./wxPosterIndex.vue?vue&type=script&lang=js"
export * from "./wxPosterIndex.vue?vue&type=script&lang=js"

import "./wxPosterIndex.vue?vue&type=style&index=0&id=72a854d0&lang=scss"
import "./wxPosterIndex.vue?vue&type=style&index=1&id=72a854d0&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a854d0"]])

export default __exports__